"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var clean = function cleanValues(text) {
  return text.replace(/^("|')|("|')$/g, '');
};

var _default = clean;
exports["default"] = _default;